import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { SelectField } from '../components/Table/fields/SelectField';
import { enumItems } from './enumItems';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { ServiceProviderStripperRole } from '../types/entities/ServiceProviderStripperRole';

export const serviceProviderStripperRole: SchemaWithClient<ServiceProviderStripperRole> = {
  name: 'Activity Stripper Role',
  pluralName: 'Activity Stripper Role',
  columns: {
    service_provider: {
      name: 'Service Provider',
      fieldRenderer: SelectField.tableAdapter(enumItems.serviceProvider),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.serviceProvider
      ),
      url: enumItems.serviceProvider.client.getAllPath,
      tempSchema: enumItems.serviceProvider,
      switchboard: true,
      readOnly: true,
    },
    stripper_role: {
      name: 'Stripper Role',
      fieldRenderer: SelectField.tableAdapter(enumItems.stripperRole),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.stripperRole
      ),
      url: enumItems.stripperRole.client.getAllPath,
      tempSchema: enumItems.stripperRole,
      switchboard: true,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/service-provider-stripper-roles'),
};
